<template></template>

<script setup>
import { initSentry } from '@/hook/sentry.js';
import { app } from '@/main.js';

initSentry(app);
</script>
